var map = {
	"./B.svg": 52,
	"./BG.svg": 53,
	"./BP.svg": 54,
	"./BR.svg": 55,
	"./C.svg": 56,
	"./CHAOS.svg": 57,
	"./E.svg": 58,
	"./G.svg": 59,
	"./GP.svg": 60,
	"./GU.svg": 61,
	"./GW.svg": 62,
	"./Q.svg": 63,
	"./R.svg": 64,
	"./RG.svg": 65,
	"./RP.svg": 66,
	"./RW.svg": 67,
	"./S.svg": 68,
	"./T.svg": 69,
	"./U.svg": 70,
	"./UB.svg": 71,
	"./UP.svg": 72,
	"./UR.svg": 73,
	"./W.svg": 74,
	"./WB.svg": 75,
	"./WP.svg": 76,
	"./WU.svg": 77
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29;


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/symbols ^\.\/.*\.svg$
// module id = 29
// module chunks = 0